import get from '../api/get';

/**
 * @typedef {Object} CustomersQueryOptions
 * @property {import('../../../app-stats/types').CustomerStatus} status
 */

/**
 *
 * @param {CustomersQueryOptions} [options]
 * @returns {import('../../../app-stats/types').Customer[]} customers
 */
export default function getCustomers({ status, approvedPendingOnly } = {}) {
    const params = new URLSearchParams();

    if (status) {
        params.append('status', status);
    }

    if (approvedPendingOnly !== undefined) {
        params.append('approvedPendingOnly', approvedPendingOnly);
    }

    const url = params.toString() ? `/api/v1/customers?${params.toString()}` : '/api/v1/customers';
    return get(url);
}
